// extracted by mini-css-extract-plugin
export default {"about":"About_about__quT7h","divider":"About_divider__V8vo2"};